import React from 'react'
import { CommitmentMail } from './CommitmentMail'

export const Permanent = () => {
  return (
    <div>
      <div className="dashboard-form proforma-left">
        <CommitmentMail type="Permanent" />
      </div>
    </div>
  )
}
